import { Injectable } from '@angular/core';
import { CallerDataService } from './../data-services/caller-data.service';
import { CallNoteRequestModel } from '../business-entities/call-note-request-model';
import { CallDialRequestModel, CallHangupRequestModel, CallTransferRequestModel, CallHistoryRequestModel } from '../business-entities/call-request-model';

@Injectable({ providedIn: 'root' })
export class CallerService {
    callerInfo : any = null;
    constructor(
        private callerDataService: CallerDataService
    ) { }

    async GetCallerInfo(model: any) {
        const response = await this.callerDataService.getCallerInfo(model);
        if ( response?.responseObject){
            return response.responseObject;
        }
        return null;
    }
    async GetCallHistory(model: any) {
        const response = await this.callerDataService.getCallHistory(model);
        if ( response?.responseObject){
            return response.responseObject;
        }
        return null;
    }
    async GetCallerVehicle(customerId: number, customerGuid) {
        const response = await this.callerDataService.getCallerVehicle(customerId, customerGuid);
        if ( response?.responseObject){
            return response.responseObject;
        }
        return null;
    }
    async addCallHistory(callHistoryModel: CallHistoryRequestModel) {
        return this.callerDataService.addCallHistory(callHistoryModel);
    }
    async saveCallNote(callNoteModel: CallNoteRequestModel) {
        return this.callerDataService.saveCallNote(callNoteModel);
    }
    async callDial(requestModel: CallDialRequestModel) {
        return this.callerDataService.callDial(requestModel);
    }
    async callTransfer(requestModel: CallTransferRequestModel) {
        return this.callerDataService.callTransfer(requestModel);
    }
    async callHangup(requestModel: CallHangupRequestModel) {
        return this.callerDataService.callHangup(requestModel);
    }
    async updateCallEnd(requestModel: any) {
        return this.callerDataService.updateCallEnd(requestModel);
    }
    async updateCallEndAll(requestModel: any) {
        return this.callerDataService.updateCallEndAll(requestModel);
    }
}